import { Observable } from "rxjs";

import {
  ErrorResponse,
  SuccessResponse,
  type AbortableRequest,
} from "../request";

export function requestToObservable<T>(
  request: () => AbortableRequest<T>,
): Observable<SuccessResponse<T> | null> {
  return new Observable<SuccessResponse<T> | null>((subscriber) => {
    try {
      const abortableRequest = request();
      abortableRequest.response
        .then((response) => {
          if (response instanceof ErrorResponse) {
            subscriber.error(response);
            return;
          }
          if (response.data instanceof ErrorResponse) {
            return subscriber.error(response.data);
          }
          if (response.data instanceof SuccessResponse) {
            subscriber.next(response.data);
          }
          subscriber.complete();
        })
        .catch((error) => {
          subscriber.error(error);
        });
      return () => {
        abortableRequest.abort();
      };
    } catch (error) {
      subscriber.error(
        new ErrorResponse(
          error instanceof Error ? error : new Error(String(error)),
        ),
      );
    }
  });
}
